import React, { useContext, useState } from "react";
import { Button, InputLabel, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { UserContext } from "../../context/UserContext";
import { checkRole } from "../../util/FormUtils";

const Upload = ({ category, handleFileChange, epId, version, labels, allowedRoles, required }) => {
    const { user } = useContext(UserContext);
    const canUpload = checkRole(user, allowedRoles);
    const [fileName, setFileName] = useState("");

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: " #f2f3f6",
                padding: "0.6em 1.2em",
                borderRadius: "8px",
            }}
        >
            <InputLabel htmlFor="data-file">
                {epId !== undefined && version > 0
                    ? `${labels[category]}: Series ${epId}, Version ${version}`
                    : epId === undefined && version > 0
                        ? `${labels[category]}: Version ${version}`
                        : labels[category]}{" "}
                {required.includes(category) && (
                    <span style={{ color: "#cc0000" }}>*</span>
                )}
            </InputLabel>
            <div style={{ display: "flex", alignItems: "center" }}>
                {fileName && (
                    <div style={{ display: "flex", alignItems: "center", marginRight: "16px" }}>
                        <Typography style={{ color: "red", marginRight: "12px" }}>
                            {"Click "}
                            <Typography
                                display="inline"
                                style={{ fontWeight: "800", paddingLeft: "2px", paddingRight: "2px" }}
                            >
                                SAVE
                            </Typography>
                            {" to complete upload:"}
                        </Typography>
                        <CloudUploadIcon style={{ marginRight: "8px", color: "#757575" }}/>
                        <Typography style={{ maxWidth: "720px", overflowWrap: "break-word", wordWrap: "break-word" }}>
                            {fileName}
                        </Typography>
                    </div>
                )}
                <label
                    htmlFor={`${category}-file`}
                    className={canUpload ? "abled-label" : "disabled-label" }
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <Button
                        variant="contained"
                        component="span"
                        color="primary"
                        startIcon={<UploadIcon />}
                        disabled={!canUpload}
                        className={canUpload ? "" : "disabled-button"}
                    >
                        UPLOAD
                    </Button>
                    <input
                        id={`${category}-file`}
                        type="file"
                        /*accept=".txt,.pdf,.xlsx,.xls,.docx,.doc"*/
                        disabled={!canUpload}
                        style={{ display: "none" }}
                        onChange={(e) => {
                            const selectedFile = e.target.files[0];
                            handleFileChange(category, selectedFile);
                            setFileName(selectedFile.name);
                        }}
                        onClick={(e) => {
                            e.target.value = null;
                        }}
                    />
                </label>
            </div>
        </div>
    );
};

export default Upload;
